module.exports = __webpack_public_path__ + "img/1269253764.0cb07e62.jpg";